import { useEffect, useMemo, useState } from 'react'
import { canPrintDocument, canSharePdf, sharePdf } from './printableDocument'

// Safari only saves a blob reliably from a real anchor, never from a scripted
// window.open. Chrome on iOS ignores the download attribute and has no
// window.print at all, so it gets a plain link to the blob instead.
function PdfActions({ pdfBlob, filename, onPrint, onError }) {
  const [pdfUrl, setPdfUrl] = useState('')
  const canShare = useMemo(
    () => canSharePdf(pdfBlob, filename),
    [pdfBlob, filename],
  )

  useEffect(() => {
    const objectUrl = URL.createObjectURL(pdfBlob)
    setPdfUrl(objectUrl)
    return () => URL.revokeObjectURL(objectUrl)
  }, [pdfBlob])

  if (!pdfUrl) return null

  return (
    <>
      <a href={pdfUrl} download={filename}>
        Save PDF
      </a>
      {canShare && (
        <button
          type='button'
          onClick={() =>
            sharePdf(pdfBlob, filename).catch((shareError) => {
              if (shareError.name !== 'AbortError') {
                onError(shareError.message || 'The PDF could not be shared.')
              }
            })
          }
        >
          Share
        </button>
      )}
      {canPrintDocument() ? (
        <button type='button' onClick={onPrint}>
          Print
        </button>
      ) : (
        <a href={pdfUrl} target='_blank' rel='noreferrer'>
          Open PDF
        </a>
      )}
    </>
  )
}

export default PdfActions
